import { createSlice } from "@reduxjs/toolkit";
import { getStripeClientSecret } from "../actions/stripePayment.actions";

const initialState = {
  isLoading: true,
  data: null,
};

const getStripeClientSecretSlice = createSlice({
  name: "Get Client Secret Key for Stripe Payment",
  initialState,
  reducers: {
    resetUserClientSecrets(state) {
      (state.isLoading = initialState?.isLoading), (state.data = initialState?.data);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStripeClientSecret.pending, (state) => {
      state.isLoading = true;
      state.data = null;
    });

    builder.addCase(getStripeClientSecret.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getStripeClientSecret.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { resetUserClientSecrets } = getStripeClientSecretSlice.actions;
export default getStripeClientSecretSlice.reducer;
